import { render, staticRenderFns } from "./gj-video-modal.vue?vue&type=template&id=7417254f&scoped=true&"
import script from "./gj-video-modal.vue?vue&type=script&lang=js&"
export * from "./gj-video-modal.vue?vue&type=script&lang=js&"
import style0 from "./gj-video-modal.vue?vue&type=style&index=0&id=7417254f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7417254f",
  null
  
)

export default component.exports